import moment from "moment";
import Vue from "vue";
import Vuex from "vuex";
import authentication from "./authentication";
import DateHandler from "@/classes/dateHandler";
import HolidayCollection from "@/classes/HolidayCollection";
import Report from "@/classes/Report";
import ReportCollection from "@/classes/ReportCollection";
import TariffCollection from "@/classes/TariffCollection";
import Employee from "@/classes/Employee";
import EmployeeCollectionAdmin from "@/classes/EmployeeCollectionAdmin";
import EmployeeCollectionUser from "@/classes/EmployeeCollectionUser";
//@ts-ignore
import { AuthenticationContext } from "vue-adal";
//@ts-ignore
import variableSalaryModal from "./modules/variableSalaryModal.js";
Vue.use(Vuex);
const axios = require("axios");
moment.updateLocale("en", {
    week: {
        dow: 1,
        doy: 4, // First week of year must contain 4 January (7 + 1 - 4)
    },
});
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
const store = new Vuex.Store({
    modules: {
        variableSalaryModal,
    },
    state: {
        loggedInAdmin: {},
        loggedInUser: {},
        getLoggedInUsersTariffs: [],
        customers: [],
        user: {},
        selectedDate: new Date(),
        //weekHours: 0,
        admin: {
            workedHoursList: "",
            workHoursListDetails: "",
        },
        selectedMonthReports: null,
        impersonatedUser: null,
        dateInfo: {},
        //new
        globalTariffs: [],
        globalEmployeesAdmin: [],
        globalEmployeesUser: [],
        reports: [],
        adminReports: [],
        loading: [],
        dateHandler: new DateHandler(),
        holidays: null,
        //color picker
        colorIndex: 0,
        assignedBackgrounds: [],
        adminTeams: [],
    },
    getters: {
        //getUserData: (state: any) => state.user,
        getSelectedDate: (state) => state.selectedDate,
        getAdminWorkedHoursList: (state) => state.admin.workedHoursList,
        getAdminWorkedHoursDetailsList: (state) => state.admin.workHoursListDetails,
        getTheme: (state) => state.theme,
        getImpersonatedUser: (state) => state.impersonatedUser,
        getLoggedInUser: (state) => state.loggedInUser,
        getLoggedInUsersTariffs: (state) => state.getLoggedInUsersTariffs,
        getDateInfo: (state) => state.dateInfo,
        getReports: (state) => state.reports,
        getLoading: (state) => state.loading,
        //new
        getGlobalTariffs: (state) => state.globalTariffs,
        getGlobalEmployeesAdmin: (state) => state.globalEmployeesAdmin,
        getGlobalEmployeesUser: (state) => state.globalEmployeesUser,
        getHolidays: (state) => state.holidays,
        getColorIndex: (state) => state.colorIndex,
        getAssignedBackgrounds: (state) => state.assignedBackgrounds,
        getAdminReports: (state) => state.adminReports,
        getLoggedInAdmin: (state) => state.loggedInAdmin,
        //getAdminTeams:(state: any) => state.adminTeams,
        getTokenProfile: (state) => AuthenticationContext.user.profile,
        getSelectedMonthReports: (state) => state.selectedMonthReports, //returns the reports for the selecte dates month
    },
    mutations: {
        //NEW
        /*setAdminTeams(state: any, teams: any){
            state.adminTeams = teams;
            (window as any).eventBus.$emit("adminTeamsLoaded");
        },*/
        setGlobalEmployeesAdmin(state, employeesJson) {
            state.globalEmployeesAdmin = new EmployeeCollectionAdmin(employeesJson);
        },
        setGlobalEmployeesUser(state, employeesJson) {
            state.globalEmployeesUser = new EmployeeCollectionUser(employeesJson);
        },
        /*setLoggedInAdmin(state: any, obj: any)
        {
            state.loggedInAdmin = new Administrator(obj);
        },*/
        setHolidays: (state, obj) => {
            const holidayCollection = obj.data;
            state.holidays = new HolidayCollection(holidayCollection);
            localStorage.setItem("geshdo.holidays-" + obj.year, JSON.stringify(state.holidays));
            window.eventBus.$emit("holidaysLoaded");
        },
        setGlobalTariffs: (state, tariffJson) => {
            const tariffs = new TariffCollection();
            tariffs.convertFromJson(tariffJson);
            state.globalTariffs = tariffs;
            localStorage.removeItem("geshdo.tariffs");
            localStorage.setItem("geshdo.tariffs", JSON.stringify(tariffJson));
            window.eventBus.$emit("tariffsLoaded");
        },
        setAdminReports: (state, reports) => {
            const collection = new ReportCollection();
            collection.importReportObjectsFromJson(reports);
            state.adminReports = collection;
            window.eventBus.$emit("adminReportsUpdated");
        },
        setReports: (state, obj) => {
            const collection = new ReportCollection();
            collection.importReportObjectsFromJson(obj.data);
            let emp = store.getters.getLoggedInUser.userId;
            if (store.getters.getImpersonatedUser !== null) {
                emp = store.getters.getImpersonatedUser.id;
            }
            state.reports[obj.month + emp] = collection;
            window.eventBus.$emit(obj.returnParameter);
            window.eventBus.$emit("ReportsUpdated");
        },
        addReport: (state, obj) => {
            let emp = store.getters.getLoggedInUser.userId;
            if (store.getters.getImpersonatedUser !== null) {
                emp = store.getters.getImpersonatedUser.id;
            }
            const newReport = new Report(obj.report);
            const reportCollection = state.reports[obj.month + emp];
            reportCollection.addReport(newReport);
            state.reports[obj.month + emp] = reportCollection;
        },
        removeReport: (state, obj) => {
            const currentMonth = obj.month;
            let emp = store.getters.getLoggedInUser.userId;
            if (store.getters.getImpersonatedUser !== null) {
                emp = store.getters.getImpersonatedUser.id;
            }
            const reportCollection = state.reports[currentMonth + emp];
            reportCollection.removeReport(obj.reportId);
            state.reports[currentMonth + emp] = reportCollection;
        },
        updateReport: (state, report) => {
            let emp = store.getters.getLoggedInUser.userId;
            if (store.getters.getImpersonatedUser !== null) {
                emp = store.getters.getImpersonatedUser.id;
            }
            const currentMonth = moment(state.selectedDate).format("YYYY-MM");
            state.reports[currentMonth + emp].updateReport(report);
        },
        //end- new
        setLoggedInUser(state, employeeObject) {
            state.loggedInUser = new Employee(employeeObject);
            localStorage.setItem("geshdo.user", JSON.stringify(state.loggedInUser));
            window.eventBus.$emit("employeeObjectUpdated");
        },
        setLoggedInUsersTariffs(state, tariffs) {
            state.getLoggedInUsersTariffs = tariffs;
            window.eventBus.$emit("loggedInUsersTariffsUpdated");
        },
        setUserImpersonation(state, user) {
            console.log("setting this imp", user);
            state.impersonatedUser = user;
            window.eventBus.$emit("userImpersonationUpdated");
        },
        adminSetWorkedHoursList(state, hoursList) {
            state.admin.workedHoursList = hoursList;
            window.eventBus.$emit("adminWorkedHoursUpdated");
        },
        adminSetWorkedDetailedHoursList(state, hoursList) {
            state.admin.workHoursListDetails = hoursList;
            window.eventBus.$emit("adminWorkedHoursDetailsUpdated");
        },
        setSelectedDate(state, obj) {
            const date = obj.date;
            const mondayFromDate = window.dateHandler.getMondayFromDate(date);
            if (window.dateHandler.areDatesInSameMonth(mondayFromDate, date)) {
                state.selectedDate = mondayFromDate;
            }
            else {
                state.selectedDate = date;
            }
            const previousMonth = window.dateHandler
                .addMonths(state.selectedDate, 1)
                .format("YYYY-MM");
            const nextMonth = window.dateHandler
                .subtractMonths(state.selectedDate, 1)
                .format("YYYY-MM");
            const currentMonth = window.dateHandler.getCurrentMonthNoDay(state.selectedDate);
            //const newDate = moment(this.$store.getters.getSelectedDate).add(1, 'weeks').startOf('isoWeek').format("YYYY-MM-DD");
            //generate date info here so we dont have to do it in the components.
            const dateInfo = {
                week: 0,
                year: "",
                monthsYear: "",
                month: "",
                weekMonths: "",
                monthNumber: "",
            };
            const monday = window.dateHandler.getMondayFromDate(state.selectedDate);
            const sunday = window.dateHandler.getSundayFromDate(state.selectedDate);
            dateInfo.week = window.dateHandler.getWeekNumber(state.selectedDate);
            if (moment(monday).year() !== moment(sunday).year()) {
                dateInfo.year =
                    moment(monday).year().toString().substring(2, 4) +
                        "/" +
                        moment(sunday).year().toString().substring(2, 4);
                dateInfo.monthsYear = window.dateHandler.getYear(state.selectedDate);
            }
            else {
                dateInfo.year = moment(monday).year().toString();
                dateInfo.monthsYear = window.dateHandler.getYear(state.selectedDate);
            }
            if (moment(monday).format("MMMM") !== moment(sunday).format("MMMM")) {
                dateInfo.weekMonths =
                    moment(monday).format("MMMM").substring(0, 3) +
                        "/" +
                        moment(sunday).format("MMMM").substring(0, 3);
                dateInfo.month = moment(state.selectedDate)
                    .format("MMMM")
                    .substring(0, 3);
            }
            else {
                dateInfo.month = moment(state.selectedDate)
                    .format("MMMM")
                    .substring(0, 3);
                dateInfo.weekMonths = moment(monday).format("MMMM").substring(0, 3);
            }
            dateInfo.monthNumber = moment(state.selectedDate).format("YYYY-MM");
            state.dateInfo = dateInfo;
            if (obj.onlyDate !== true) {
                store.dispatch("loadSelectedMonthReports", state.selectedDate);
            }
        },
        // trigger the loader component to init or destroy a new loader
        setLoaderMessage: (state, obj) => {
            window.eventBus.$emit("showLoader", obj);
        },
        // creates a new toast by triggering an eventbus function in Toast.vue
        setToastMessage: (state, obj) => {
            window.eventBus.$emit("newToast", obj);
        },
        setLoadingFunction: (state, name) => {
            state.loading.push(name);
        },
        removeLoadingFunction: (state, name) => {
            state.loading = state.loading.splice(state.loading.indexOf(name), 1);
        },
    },
    actions: {
        async getMyTariffs(state) {
            try {
                const tariffs = (await axios.get("/tariffs")).data;
                const tariffCollection = new TariffCollection();
                tariffCollection.convertFromJson(tariffs);
                state.commit("setLoggedInUsersTariffs", tariffCollection);
                return tariffs;
            }
            catch (err) {
                console.log(err);
            }
        },
        /***************************************************************/
        /*                 AdminEmployee Controller                    */
        /***************************************************************/
        //creates an employee
        async getEmployeeBenefits(state, userId) {
            const url = "/admin/employees/" + userId + "/benefits";
            const promise = await axios.get(url);
            console.log("promise: ", promise);
            return promise;
        },
        //loads a level benefit
        async getBenefitLevel(state, obj) {
            const url = "/admin/employees/" +
                obj.userId +
                "/benefits/" +
                obj.benefitId +
                "/level";
            const promise = await axios.get(url);
            return promise;
        },
        async getFixedSalary(state, obj) {
            const url = "/admin/employees/" +
                obj.userId +
                "/benefits/" +
                obj.benefitId +
                "/fixed";
            const promise = await axios.get(url);
            return promise;
        },
        //updates or creates a level benefit
        async saveBenefitLevel(state, obj) {
            const { keepLevelHourProgress } = obj;
            const params = new URLSearchParams();
            if (keepLevelHourProgress === true) {
                params.append("keepLevelHourProgress", JSON.stringify(keepLevelHourProgress));
            }
            const data = obj.level; //set the entire level as the object
            const promise = await axios.put("/admin/employees/" + obj.userId + "/benefits/level", data, { params });
            return promise;
        },
        //removes a level from an employee
        async deleteEmployeeBenefit(state, obj) {
            const promise = axios.delete("/admin/employees/" + obj.userId + "/benefits/" + obj.benefitId);
            return promise;
        },
        //creates an employee
        async updateEmployee(state, obj) {
            const url = "/admin/employees/" + obj.userId;
            const promise = await axios.put(url, obj);
            return promise;
        },
        //loads the employee tariffs with the given userId
        async loadEmployeeTariffs(state, userId) {
            const url = "/admin/employees/" + userId + "/tariffs";
            const promise = await axios.get(url);
            return promise;
        },
        //creates an employee
        async createEmployeeAsync(state, obj) {
            const url = "/admin/employees/" + obj.userId;
            const promise = await axios.post(url, obj);
            return promise;
        },
        //deletes an employee (only used when an employee is created incorrectly)
        async deleteEmployeeAsync(state, obj) {
            const url = "/admin/employees/" + obj.userId;
            const promise = await axios.delete(url);
            return promise;
        },
        //get the employee bonus
        async getAdminEmployeeBonus(state, year) {
            const url = "admin/employees/bonus/" + year;
            const promise = await axios.get(url);
            return promise;
        },
        //get the salaries for the users
        async getUserSalaries(state, obj) {
            const promise = axios.get("/admin/employees/salaries/" + obj.month);
            return promise;
        },
        //download the user salaries as CSV
        async downloadUserSalariesCSV(state, obj) {
            const promise = axios.get("/admin/employees/salaries/" + obj.month + "?fileOutput=csv");
            return promise;
        },
        //Team Manager
        async adminUpdateTeamManagerBenefit(state, obj) {
            const url = `/admin/employees/${obj.userId}/benefits/teammanager`;
            const promise = await axios.put(url, obj.data);
            return promise;
        },
        /***************************************************************/
        /*                     METADATA Controller                     */
        /***************************************************************/
        // retrieve a years holiday
        async loadHolidaysAsync(_state, obj) {
            const start = "2016-01-01 00:00"; // 🎉
            const end = moment()
                .year(obj.year)
                .endOf("year")
                .add(2, "years")
                .format("YYYY-MM-DD 23:59");
            const createdParams = new URLSearchParams();
            createdParams.append("from", start);
            createdParams.append("to", end);
            const data = { params: createdParams };
            const promise = axios.get("/metadata/holidays/se", data);
            return promise;
        },
        //gets all the levels in the system
        async loadGlobalLevelsAsnyc(_state) {
            const promise = await axios.get("/metadata/levels");
            return promise;
        },
        //loads all the tariffs
        async loadGlobalTariffsAsync(_state) {
            const url = "/tariffs/all";
            const promise = axios.get(url);
            return promise;
        },
        //loads all the tags
        async loadTags(_state) {
            const promise = await axios.get("/metadata/tags");
            return promise;
        },
        //returns all the absence reports
        async loadAbsence(_state, obj) {
            const promise = await axios.get("/metadata/absence/" + obj.year + "/" + obj.month);
            return promise;
        },
        //loads the teams for a given year and month
        async loadUserTeams(_state, obj) {
            const url = "/metadata/teams/" + obj.year + "/" + obj.month;
            const promise = await axios.get(url, obj);
            return promise;
        },
        //returns all the users
        async getAllUsers(_state) {
            const promise = await axios.get("/metadata/users");
            return promise;
        },
        //metadata/bonus not implemented
        /*******************************loadTimeReports*************************************
        //returnParameter: Name of the return parameter
        //ex: {from: 2020-01-01 00:00, to: 2020-01-25 23:59, returnParameter: 'reportsLoaded'}
        ************************************************************************************/
        loadSelectedMonthReports(_state, date) {
            const start = moment(date)
                .startOf("month")
                .subtract(7, "days")
                .format("YYYY-MM-DD[T]00:00:00[Z]");
            const end = moment(date)
                .endOf("month")
                .add(7, "days")
                .format("YYYY-MM-DD[T]23:59:59[Z]");
            const createdParams = new URLSearchParams();
            createdParams.append("from", start);
            createdParams.append("to", end);
            const data = { params: createdParams };
            axios
                .get("/reports", data)
                .then((response) => {
                const reports = response.data;
                this.state.selectedMonthReports = reports;
                window.eventBus.$emit("selectedMonthReportsUpdated");
            })
                .catch((err) => {
                errorHandler(err, "loadSelectedMonthReports");
            });
        },
        async loadAdminTimeReportsAsync(_state, obj) {
            const start = moment(obj.date)
                .startOf("month")
                .format("YYYY-MM-DD[T]00:00:00[Z]");
            const end = moment(obj.date)
                .endOf("month")
                .format("YYYY-MM-DD[T]23:59:59[Z]");
            const createdParams = new URLSearchParams();
            createdParams.append("from", start);
            createdParams.append("to", end);
            const data = { params: createdParams };
            const promise = await axios.get("/admin/reports", data);
            return promise;
        },
        async loadTimeReportsAsync(_state, obj) {
            const start = obj.start;
            const end = obj.end;
            const createdParams = new URLSearchParams();
            createdParams.append("from", start);
            createdParams.append("to", end);
            const data = { params: createdParams };
            const url = "/reports";
            const promise = await axios.get(url, data);
            return promise;
        },
        /***************************************************************/
        /*                       Team Manager                             */
        /***************************************************************/
        async getTeamManagerReportsAsync(_state, obj) {
            const createdParams = new URLSearchParams();
            createdParams.append("from", window.dateHandler.convertToUTCTime(obj.from));
            createdParams.append("to", window.dateHandler.convertToUTCTime(obj.to));
            const data = { params: createdParams };
            const url = "/teams/" + obj.teamId + "/reports";
            const promise = await axios.get(url, data);
            return promise;
        },
        getTeamManagerReports(_state, obj) {
            const start = window.dateHandler
                .getStartOfMonth(obj.date)
                .format("YYYY-MM-DD");
            const end = window.dateHandler
                .getEndOfMonth(obj.date)
                .format("YYYY-MM-DD");
            const createdParams = new URLSearchParams();
            createdParams.append("from", start);
            createdParams.append("to", end);
            const data = { params: createdParams };
            const url = "/teamlead/reports";
            axios
                .get(url, data)
                .then((response) => {
                window.eventBus.$emit("teamManagerReportsLoaded", response.data);
            })
                .catch((err) => {
                errorHandler(err, "getTeamManagerReports");
            });
        },
        getTeamManagerSalary(_state, obj) {
            const start = window.dateHandler
                .getStartOfMonth(obj.date)
                .format("YYYY-MM-DD");
            const createdParams = new URLSearchParams();
            createdParams.append("period", start);
            const url = "/teamlead/salary";
            axios
                .get(url)
                .then((response) => {
                window.eventBus.$emit("teamManagerSalaryLoaded", response.data);
            })
                .catch((err) => {
                errorHandler(err, "getTeamManagerSalary");
            });
        },
        /***************************************************************/
        /*                           ABSENCE                           */
        /***************************************************************/
        /***************************************************************/
        /*                          USER                               */
        /***************************************************************/
        //vet inte om den används eller inte
        async getCurrentUser(state) {
            const promise = await axios.get("/user");
            return promise;
        },
        async getUser(state, userId) {
            const data = { userId };
            const promise = await axios.get("/user", data);
            return promise;
        },
        //edits a user
        async editUser(state, obj) {
            const url = "/admin/user/" + obj.id;
            const promise = await axios.put(url, obj);
            return promise;
        },
        // creates a new user in the system.
        async createNewUser(state, obj) {
            const url = "/admin/user";
            const promise = await axios.post(url, obj);
            return promise;
        },
        //deletes a user
        async deleteUser(state, obj) {
            const url = "/admin/user/" + obj.id;
            const promise = await axios.delete(url);
            return promise;
        },
        async validateEmployeeAsync(state) {
            const promise = await axios.get("/employee");
            return promise;
        },
        async lockReportsAsync(state, obj) {
            const closeDate = moment(obj.closeDate).format("YYYY-MM-DD[T]23:59:59[Z]");
            const url = "/reports/close?newClosedReportDate=" + closeDate;
            const promise = await axios.put(url);
            return promise;
        },
        /***************************************************************/
        /*                  EMPLOYEE TIME REPORTS                      */
        /***************************************************************/
        async createTimeReport(state, report) {
            const url = "/reports";
            const data = {
                from: report.from,
                to: report.to,
                tariffId: report.tariffId,
                comment: report.comment,
            };
            const promise = await axios.post(url, data);
            return promise;
        },
        async removeTimeReport(state, report) {
            const url = "/reports/" + report.id;
            const promise = await axios.delete(url);
            return promise;
        },
        async modifyTimeReport(state, report) {
            const url = "/reports/" + report.id;
            const data = {
                from: report.from,
                to: report.to,
                tariffId: report.tariffId,
                comment: report.comment,
            };
            const promise = await axios.put(url, data);
            return promise;
        },
        /***************************************************************/
        /*                       ADMIN TARIFFS                         */
        /***************************************************************/
        //Returns the tariffs for the given user (replaces the same call for employees)
        async adminGetUserTariffsAsync(state, userId) {
            const url = "/admin/employees/" + userId + "/tariffs";
            const promise = await axios.get(url);
            return promise;
        },
        async adminAddUserTariffAsync(state, obj) {
            const url = "/admin/employees/" + obj.userId + "/tariffs/" + obj.tariffId;
            const promise = await axios.post(url);
            return promise;
        },
        async adminRemoveUserTariffAsync(state, obj) {
            const url = "/admin/employees/" + obj.userId + "/tariffs/" + obj.tariffId;
            const promise = await axios.delete(url);
            return promise;
        },
        adminGetEmployeeTariffs(state, userId) {
            const url = "/admin/employees/" + userId + "/tariffs";
            axios
                .get(url)
                .then((response) => {
                const employeeTariffs = new TariffCollection();
                employeeTariffs.convertFromJson(response.data);
                window.eventBus.$emit("adminGetEmployeeTariffsLoaded", employeeTariffs);
            })
                .catch((err) => {
                errorHandler(err, "adminGetEmployeeTariffs");
            });
        },
        async adminLoadTariffsAsync(state) {
            const url = "/admin/tariffs";
            const promise = await axios.put(url);
            return promise;
        },
        async loadAdminUser(state) {
            const url = "/admin";
            const promise = await axios.get(url);
            return promise;
        },
        async adminLoadEmployees(context, state) {
            const promise = await axios.get("/admin/employees");
            return promise;
        },
        async createAdminTariffAsync(state, obj) {
            const url = "/admin/tariffs";
            const promise = await axios.post(url, obj);
            return promise;
        },
        async updateAdminTariffAsync(state, obj) {
            const url = "/admin/tariffs/" + obj.id;
            const promise = await axios.put(url, obj);
            return promise;
        },
        /***************************************************************/
        /*                        USER TEAMS                           */
        /***************************************************************/
        /***************************************************************/
        /*                       ADMIN TEAMS                           */
        /***************************************************************/
        async getMyTeamMembers(state) {
            // TODO TIMENOW NEXT - Check Admin -> Director -> TeamManager -> Employee
            const user = state.getters.getTokenProfile;
            let users = [];
            // Add all users
            if (user.roles.includes("Admin")) {
                const allUsers = (await axios.get(`/metadata/users`)).data.map((user) => {
                    return { ...user, userId: user.id };
                });
                return allUsers;
            }
            // users = users.concat((await axios.get(`/admin/employees`)).data);
            // users = users.concat((await axios.get(`/admin/consultants`)).data);
            // users = users.concat((await axios.get(`/admin/interns`)).data);
            // }
            // Impersonation not allowed - return empty
            if (user.roles.length === 1 && user.roles[0] === "Employee") {
                return [];
            }
            const allTeams = (await state.dispatch("loadTeams")).data;
            // Add all users from possibly multiple teams
            if (user.roles.includes("TeamManager")) {
                const teamsBelongingToUser = allTeams.filter((team) => team.teamManagerId === state.state.loggedInUser.userId);
                const aoaUsers = await Promise.all(teamsBelongingToUser.map(async (team) => {
                    return (await axios.get(`/admin/teams/${team.id}/members`)).data;
                }));
                aoaUsers.forEach((array) => (users = users.concat(array)));
            }
            // Add all users from the entire stack assosiated with the director
            if (user.roles.includes("Director")) {
                const teamsBelongingToUser = allTeams.filter((team) => team.directorId === state.state.loggedInUser.userId);
                const aoaUsers = await Promise.all(teamsBelongingToUser.map(async (team) => {
                    return (await axios.get(`/admin/teams/${team.id}/members`)).data;
                }));
                aoaUsers.forEach((array) => (users = users.concat(array)));
            }
            // Remove duplicates
            return [...new Set(users)];
        },
        async adminLoadTeamsAsync(state, obj) {
            const url = "/admin/teams";
            const promise = await axios.get(url);
            return promise;
        },
        async adminCreateTeamAsync(state, obj) {
            const url = "/admin/teams";
            // const data = { name: obj.name, teamleadId: obj.leadId, from: obj.from };
            const promise = await axios.post(url, obj);
            return promise;
        },
        async adminRemoveTeamAsync(state, obj) {
            const url = "/admin/teams/" + obj.teamId;
            const promise = await axios.delete(url);
            return promise;
        },
        async adminUpdateTeamAsync(state, obj) {
            const url = "admin/teams/" + obj.id;
            const promise = await axios.put(url, obj);
            return promise;
        },
        async adminLoadTeamMembersAsync(state, obj) {
            const url = "admin/teams/" + obj.id + "/members";
            const promise = await axios.get(url, obj);
            return promise;
        },
        async adminAddTeamMemberAsync(state, obj) {
            const url = "admin/teams/" + obj.teamId + "/members/" + obj.member.id;
            const data = {
                from: obj.member.from,
                to: obj.member.to,
            };
            const promise = await axios.put(url, data);
            return promise;
        },
        async adminUpdateTeamMemberAsync(state, obj) {
            //set the id value to userId instead of just ID if single user
            if (obj.member.userId === undefined || obj.member.userId === null) {
                obj.member.userId = obj.member.id;
            }
            const url = "admin/teams/" + obj.teamId + "/members/" + obj.member.userId;
            const data = {
                from: obj.member.from,
                to: obj.member.to,
            };
            const promise = await axios.put(url, data);
            return promise;
        },
        async adminRemoveTeamMemberAsync(state, obj) {
            //set the id value to userId instead of just ID if single user
            if (obj.member.userId === undefined || obj.member.userId === null) {
                obj.member.userId = obj.member.id;
            }
            const url = "admin/teams/" + obj.teamId + "/members/" + obj.member.userId;
            const data = {
                from: obj.member.from,
                to: obj.member.to,
            };
            const promise = await axios.delete(url, data);
            return promise;
        },
        /***************************************************************/
        /*                         INTERNS                             */
        /***************************************************************/
        async getAdminInterns(state, obj) {
            const url = "/admin/interns";
            const promise = await axios.get(url);
            return promise;
        },
        async addAdminIntern(state, user) {
            const url = "/admin/interns/" + user.id;
            const data = {
                from: user.from,
                to: user.to,
            };
            const promise = await axios.post(url, data);
            return promise;
        },
        async updateAdminIntern(state, intern) {
            const url = "/admin/interns/" + intern.userId;
            const promise = await axios.put(url, intern);
            return promise;
        },
        async getExternalSupport(state) {
            const url = "/admin/externalsupport";
            const promise = await axios.get(url);
            return promise;
        },
        async createExternalSupport(state, user) {
            const url = "/admin/externalsupport/" + user.userId;
            const data = {
                from: user.from,
                to: user.to || null,
            };
            const promise = await axios.post(url, data);
            return promise;
        },
        async updateExternalSupport(state, user) {
            const url = "/admin/externalsupport/" + user.userId;
            const promise = await axios.put(url, {
                from: user.from,
                to: user.to || null,
            });
            return promise;
        },
        async deleteExternalSupport(state, user) {
            const url = "/admin/externalsupport/" + user.userId;
            const promise = await axios.delete(url);
            return promise;
        },
        /***************************************************************/
        /*                       AdminEmployee                        */
        /***************************************************************/
        async adminGetAllExternalConsultants(state) {
            const url = "/admin/consultants";
            const promise = await axios.get(url);
            return promise;
        },
        async createExternalConsultantAsync(state, user) {
            const url = "/admin/consultants/" + user.id;
            const data = {
                from: user.from,
                to: user.to || null,
            };
            const promise = await axios.post(url, data);
            return promise;
        },
        async updateExternalConsultant(state, consultant) {
            const url = "/admin/consultants/" + consultant.userId;
            const promise = await axios.put(url, consultant);
            return promise;
        },
        async deleteExternalConsultantAsync(state, consultant) {
            const url = "/admin/consultant/" + consultant.userId;
            const promise = await axios.delete(url);
            //const promise = await axios.delete({ url, Allow: "DELETE", Method: "DELETE" });
            return promise;
        },
        /***************************************************************/
        /*                       AdminEmployee                        */
        /***************************************************************/
        //returns all employees for an admin
        async adminGetAllEmployees(state) {
            const url = "/admin/employees";
            const promise = await axios.get(url);
            return promise;
        },
        //returns all employees for an admin
        async getEmployeeLevels(state, userId) {
            const url = "/admin/employees/" + userId + "/levels";
            const promise = await axios.get(url);
            return promise;
        },
        /***************************************************************/
        /*                    ADMIN FIXED SALARY                       */
        /***************************************************************/
        adminRemoveFixedBenefit(state, obj) {
            const url = "/admin/employees/" + obj.userId + "/benefits/fixed/" + obj.id;
            axios
                .delete(url)
                .then((response) => {
                state.dispatch("adminLoadTeams");
            })
                .catch((err) => {
                errorHandler(err, "adminRemoveFixedBenefit");
            });
        },
        async adminRemoveFixedBenefitAsync(state, obj) {
            const url = "/admin/employees/" + obj.userId + "/benefits/fixed/" + obj.id;
            const promise = await axios.delete(url);
            return promise;
        },
        async adminUpdateFixedBenefitAsync(state, obj) {
            const url = "/admin/employees/" + obj.userId + "/benefits/fixed/";
            const promise = await axios.put(url, obj.data);
            return promise;
        },
        /***************************************************************/
        /*                       ADMIN Levels                          */
        /***************************************************************/
        async updateAdminLevelAsync(state, obj) {
            const promise = await axios.put("/admin/levels/" + obj.id, obj);
            return promise;
        },
        async createAdminLevelAsync(state, obj) {
            const promise = await axios.post("/admin/levels/", obj);
            return promise;
        },
        async deleteAdminLevelAsync(state, obj) {
            const promise = await axios.delete("/admin/levels/" + obj.id);
            return promise;
        },
        async adminLockReports(state, obj) {
            const { userId, closedReportsDate } = obj;
            try {
                await axios({
                    method: "PUT",
                    url: `/reports/close?newClosedReportDate=${closedReportsDate}`,
                    headers: {
                        userId,
                    },
                });
                store.dispatch("ToastMessage", { type: "any", message: "Week closed" });
                store.dispatch("validateEmployee");
                window.eventBus.$emit("reportsClosed");
            }
            catch (err) {
                errorHandler(err, "adminLockReports");
            }
        },
        /***************************************************************/
        /*                     STAKEHOLDER functions                   */
        /***************************************************************/
        async createStakeholderConnectionAsync(state, obj) {
            const url = "/admin/stakeholders";
            const promise = await axios.post(url, obj);
            return promise;
        },
        async removeStakeholderconnectionAsync(state, obj) {
            const url = "/admin/stakeholders/" + obj.email + "/" + obj.tariffId;
            const promise = await axios.delete(url);
            return promise;
        },
        async getStakeholderListAsync(state) {
            const url = "/admin/stakeholders";
            const promise = await axios.get(url);
            return promise;
        },
        downloadStakeholderReportsCSV(state, obj) {
            const start = moment(obj.date).startOf("month").format("YYYY-MM-DD");
            const end = moment(obj.date).endOf("month").format("YYYY-MM-DD");
            const url = `/stakeholder/reports?fileOutput=csv&from=${start}&to=${end}`;
            const promise = axios({ url, method: "GET" });
            return promise;
        },
        async downloadSalaryCSV(state, obj) {
            const year = obj.year;
            const month = obj.month;
            const url = `/admin/payments/employees/${year}/${month}/?fileOutput=csv`;
            const response = await axios({ url, method: "GET" });
            return response;
        },
        /***************************************************************/
        /*                      User TEAM functions                   */
        /***************************************************************/
        //TODO: Detta måste vara ett nytt anrop sen utan restrictions
        async loadTeams(state, obj) {
            const url = "/admin/teams";
            const promise = await axios.get(url);
            return promise;
        },
        async loadTeamReportsAsync(state, obj) {
            const createdParams = new URLSearchParams();
            createdParams.append("from", window.dateHandler.convertToUTCTime(obj.from));
            createdParams.append("to", window.dateHandler.convertToUTCTime(obj.to));
            const data = { params: createdParams };
            const url = "/teams/" + obj.teamId + "/reports";
            const promise = await axios.get(url, data);
            return promise;
        },
        /***************************************************************/
        /*                    SALES ORDERS functions                   */
        /***************************************************************/
        async getSalesOrdersAsync(state) {
            const url = "/admin/salesorders";
            const promise = await axios.get(url);
            return promise;
        },
        async updateSalesOrder(state, obj) {
            const url = "/admin/salesorders/" + obj.id;
            const promise = await axios.put(url, obj);
            return promise;
        },
        async createSalesOrder(state, obj) {
            const url = "/admin/salesorders";
            const promise = await axios.post(url, obj);
            return promise;
        },
        async deleteSalesOrder(state, obj) {
            const url = "/admin/salesorders/" + obj.id;
            const promise = await axios.delete(url);
            return promise;
        },
        /********************END NEW FUNCTIONS************************** */
        //old functions
        // initiates a toast message
        ToastMessage: (state, obj) => {
            state.commit("setToastMessage", obj);
        },
        // initiates a loader screen
        showLoader: (state, obj) => {
            state.commit("setLoaderMessage", obj);
        },
        // sign out the user
        signOut(state) {
            authentication.signOut();
        },
        loadNonWorkingDays(state, obj) {
            const createdParams = new URLSearchParams();
            createdParams.append("from", obj.from);
            createdParams.append("to", obj.to);
            const data = { params: createdParams };
            let reports;
            axios
                .get("/planner/notworking", data)
                .then((response) => {
                reports = response.data;
                window.eventBus.$emit("nonWorkingDaysLoaded", reports);
                console.log("nonWorkinglist", reports);
            })
                .catch((err) => {
                errorHandler(err, "loadNonWorkingDays");
            });
        },
        lockReports(state, obj) {
            const closeDate = moment(obj.closeDate).utc().toISOString();
            axios
                .put("/reports/close?newClosedReportDate=" + closeDate)
                .then((response) => {
                store.dispatch("ToastMessage", {
                    type: "any",
                    message: "Week closed",
                });
                store.dispatch("validateEmployee");
                window.eventBus.$emit("reportsClosed");
            })
                .catch((err) => {
                errorHandler(err, "lockReports");
            });
        },
        getEmployeesAdmin(state) {
            axios
                .get("/admin/employees")
                .then((response) => {
                const employees = response.data;
                window.eventBus.$emit("employeesAdminLoaded", employees);
            })
                .catch((err) => {
                errorHandler(err, "getEmployeeAdmin");
            });
        },
        // updateEmployeesAdmin(state: any, obj: any) {
        //   axios.put('/admin/employees/' + obj.userId, obj)
        //     .catch((err: any) => {
        //       errorHandler(err, 'updateEmployeesAdmin');
        //     });
        // },
        async getAdminTariffs(state) {
            try {
                const response = await axios.get("/admin/tariffs");
                const tariffs = response.data;
                return tariffs;
            }
            catch (err) {
                errorHandler(err, "getAdminTariffs");
                return [];
            }
        },
        getStakeholderReports(state, obj) {
            const createdParams = new URLSearchParams();
            createdParams.append("from", obj.from);
            createdParams.append("to", obj.to);
            const data = { params: createdParams };
            axios
                .get("/stakeholder/reports", data)
                .then((response) => {
                const stakeholderReports = response.data;
                window.eventBus.$emit("stakeholderReportsLoaded", stakeholderReports);
            })
                .catch((err) => {
                errorHandler(err, "getStakeholderReports");
            });
        },
        impersonateUser(state, userObject) {
            state.commit("setUserImpersonation", userObject);
            state
                .dispatch("validateEmployeeAsync")
                .then((response) => {
                const employeeReturn = response.data;
                state.commit("setLoggedInUser", employeeReturn);
                state.employee = state.getters.getLoggedInUser;
            })
                .catch((error) => {
                state.commit("setUserImpersonation", null);
                console.log(error);
            });
        },
        async getClosedReportsDate(state) {
            const promise = await axios.get("/reports/close");
            return promise;
        },
        validateEmployee(state) {
            const localEmployee = retrieveFromLocalStorage("geshdo.employee");
            if (localEmployee !== undefined) {
                console.time("Local-ValidateEmployee");
                state.commit("setLoggedInUser", localEmployee);
                console.timeEnd("Local-ValidateEmployee");
            }
            console.time("API-ValidateEmployee");
            axios
                .get("/employee")
                .then((response) => {
                console.timeEnd("API-ValidateEmployee");
                const employeeObject = response.data;
                state.commit("setLoggedInUser", employeeObject);
            })
                .catch((err) => {
                errorHandler(err, "validateEmployee");
            });
        },
        /***************************************************************/
        /*                      INVOICE API CALLS                   */
        /***************************************************************/
        async fetchInvoices(state, args) {
            if (!args.selectedYear || !args.selectedMonth) {
                return console.error("No year or month selected");
            }
            const url = `/admin/invoices/${args.selectedYear}/${args.selectedMonth}`;
            const promise = await axios.get(url);
            return promise;
        },
        async fetchInvoiceDetails(state, invoiceId) {
            if (!invoiceId) {
                return console.error("No invoiceId selected");
            }
            const url = `/admin/invoices/${invoiceId}/details`;
            const promise = await axios.get(url);
            return promise;
        },
        async createInvoice(state, invoiceData) {
            if (!invoiceData) {
                return console.error("Invoice Data is not defined");
            }
            const url = `/admin/invoices/${invoiceData.year}/${invoiceData.month}/${invoiceData.salesOrderId}`;
            const data = { invoiceDate: invoiceData.invoiceDate };
            const promise = await axios.put(url, data);
            return promise;
        },
    },
});
export default store;
function errorHandler(err, method) {
    console.log("------------" + method + "--------------");
    if (err.response) {
        store.dispatch("ToastMessage", {
            type: "error",
            message: "Error when invoking " + method + ": " + err,
        });
        console.log("Error when invoking " + method + ": ", err.response);
        console.log("Error response:");
        console.log(err.response.data);
    }
    if (err.request) {
        console.log("Error request:");
        console.log(err.request);
    }
    else {
        console.log("Error when invoking " + method + ": " + err);
        console.log("Error", err.message);
    }
    if (err.config !== undefined) {
        console.log("Error Config:");
        console.log(err.config);
    }
    console.log("------------------------------------------------");
}
function retrieveFromLocalStorage(name) {
    if (localStorage.getItem(name)) {
        try {
            const items = JSON.parse(localStorage.getItem(name));
            return items;
        }
        catch (e) {
            console.log("Unable to retireve from local storage: [" + name + "]" + e);
            localStorage.removeItem(name);
        }
    }
}
axios.interceptors.request.use((config) => {
    /*authentication.acquireToken().then((token: any) => {
        console.log(token)
        // Set default request headers
        //console.log(config.url)
        //config.headers.ContentType = 'application/json';
        //console.log("token in store", token.idToken.rawIdToken)
        config.headers.Authorization = 'Bearer ' + token;
        */
    AuthenticationContext.acquireToken(process.env.VUE_APP_AZURE_CLIENT_ID, (err, token) => {
        if (err) {
            const errCode = err.split(":")[0];
            switch (errCode) {
                case "AADSTS50058": // Need to prompt for user sign in
                    AuthenticationContext.login();
                    break;
                case "AADSTS65001": // Token is invalid; grab a new one
                    AuthenticationContext.acquireTokenRedirect(process.env.VUE_APP_AZURE_CLIENT_ID);
                    break;
                case "AADSTS16000": // No Access
                default:
                    // Need a pop-up forcing a login
                    AuthenticationContext.login();
                    break;
            }
            return;
        }
        if (config && config.headers) {
            config.headers.Authorization = "BEARER " + token;
        }
    });
    const user = store.getters.getImpersonatedUser;
    if (user !== undefined && user !== null && config.method !== "options") {
        console.log("impersonated User TO USE FOR API CALL", user);
        if (config && config.headers) {
            if (user.id !== undefined) {
                config.headers.userId = user.id; //adds a user id for impersonation for admins
            }
            else if (user.email !== undefined) {
                config.headers.userId = user.email; //adds a user id for impersonation for admins
            }
        }
    }
    return config;
});
const getToken = (resource, http, cb) => {
    AuthenticationContext.acquireToken(resource, (err, token) => {
        if (err) {
            const errCode = err.split(":")[0];
            switch (errCode) {
                case "AADSTS50058": // Need to prompt for user sign in
                    AuthenticationContext.login();
                    break;
                case "AADSTS65001": // Token is invalid; grab a new one
                    AuthenticationContext.acquireTokenRedirect(resource);
                    break;
                case "AADSTS16000": // No Access
                    console.log("du har inte access");
                    break;
                default:
                    AuthenticationContext.login(); // Need a pop-up forcing a login
                    break;
            }
            cb(new Error("Failed to acquire token"));
            return;
        }
        http.defaults.headers["Authorization"] = `BEARER ${token}`;
        cb(null, token);
    });
};
axios.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (error.response.status === 401) {
        AuthenticationContext.adalContext.clearCacheForResource(process.env.VUE_APP_AZURE_CLIENT_ID);
        return new Promise((resolve, reject) => getToken(process.env.VUE_APP_AZURE_CLIENT_ID, axios, () => {
            const config = error.response.config;
            config.headers.Authorization =
                axios.defaults.headers["Authorization"];
            axios({
                method: config.method,
                url: config.url,
                data: config.data,
                headers: {
                    Accept: config.headers["Accept"],
                    Authorization: config.headers["Authorization"],
                    "Content-Type": config.headers["Content-Type"],
                },
            }).then((res) => resolve(res), (err) => reject(err));
        }));
    }
    else {
        return Promise.reject(error);
    }
});
